import React from "react";
import hoistNonReactStatic from "hoist-non-react-statics";
import { DesignConsumer } from "./context";

let withDesignConsumer;

if (process.env.DESIGNER === "yes") {
  withDesignConsumer = WrappedComponent => {
    const WithDesignConsumer = ({ children, ...rest }) => (
      <DesignConsumer>
        {state => (
          <WrappedComponent {...rest} {...state}>
            {children}
          </WrappedComponent>
        )}
      </DesignConsumer>
    );

    WithDesignConsumer.displayName = `withDesignConsumer(${WrappedComponent.displayName ||
      WrappedComponent.name})`;
    WithDesignConsumer.WrappedComponent = WrappedComponent;

    return hoistNonReactStatic(WithDesignConsumer, WrappedComponent);
  };
} else {
  withDesignConsumer = WrappedComponent => WrappedComponent;
}

export default withDesignConsumer;
